import { frontendURL } from '../../../helper/URLHelper';
import PrateleiraHost from './PrateleiraHost.vue';
import {
  LAIS_CAPTACAO_PERMISSIONS,
  laisCanonicalRedirect,
} from '../laisRouteHelpers';

const PRATELEIRA_CAPTACAO_META = {
  permissions: LAIS_CAPTACAO_PERMISSIONS,
};

const PRATELEIRA_ATUALIZACAO_META = {
  permissions: ['administrator'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/prateleira'),
    name: 'lais_prateleira_index',
    redirect: laisCanonicalRedirect('lais_prateleira_captacao'),
    meta: PRATELEIRA_CAPTACAO_META,
  },
  {
    path: frontendURL('accounts/:accountId/prateleira/atualizacao'),
    name: 'lais_prateleira_atualizacao',
    component: PrateleiraHost,
    meta: PRATELEIRA_ATUALIZACAO_META,
  },
  {
    path: frontendURL('accounts/:accountId/prateleira/captacao'),
    name: 'lais_prateleira_captacao',
    component: PrateleiraHost,
    meta: PRATELEIRA_CAPTACAO_META,
  },
  {
    path: frontendURL('accounts/:accountId/prateleira/importacao'),
    name: 'lais_prateleira_importacao',
    component: PrateleiraHost,
    meta: PRATELEIRA_CAPTACAO_META,
  },
  {
    path: frontendURL('accounts/:accountId/prateleira/publicacao'),
    name: 'lais_prateleira_publicacao',
    component: PrateleiraHost,
    meta: PRATELEIRA_CAPTACAO_META,
  },
  {
    path: frontendURL('accounts/:accountId/prateleira/integridade'),
    name: 'lais_prateleira_integridade',
    component: PrateleiraHost,
    meta: PRATELEIRA_CAPTACAO_META,
  },
];
